export default "__VITE_ASSET__CzkdbM____"